define(["require", "exports", "tslib", "file-saver", "xlsx"], function (require, exports, tslib_1, file_saver_1, xlsx_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.exportTable2Excel = void 0;
    xlsx_1 = (0, tslib_1.__importDefault)(xlsx_1);
    var Workbook = (function () {
        function Workbook() {
            this.SheetNames = [];
            this.Sheets = {};
        }
        return Workbook;
    }());
    var generateArray = function (table) {
        var out = [];
        var rows = table.querySelectorAll('tr');
        var ranges = [];
        var _loop_1 = function (R) {
            var outRow = [];
            var row = rows[R];
            var columns = row.querySelectorAll('td');
            for (var C = 0; C < columns.length; ++C) {
                var cell = columns[C];
                var colspanStr = cell.getAttribute('colspan');
                var rowspanStr = cell.getAttribute('rowspan');
                var colspan = void 0;
                var rowspan = void 0;
                if (colspanStr) {
                    colspan = parseInt(colspanStr, 10);
                }
                if (rowspanStr) {
                    rowspan = parseInt(rowspanStr, 10);
                }
                var cellValue = cell.innerText;
                ranges.forEach(function (range) {
                    if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
                        for (var i = 0; i <= range.e.c - range.s.c; ++i)
                            outRow.push(null);
                    }
                });
                if (rowspan || colspan) {
                    rowspan = rowspan || 1;
                    colspan = colspan || 1;
                    ranges.push({
                        s: {
                            r: R,
                            c: outRow.length
                        },
                        e: {
                            r: Number(R) + Number(rowspan) - 1,
                            c: Number(outRow.length) + Number(colspan) - 1
                        }
                    });
                }
                outRow.push(cellValue !== '' ? cellValue : null);
                if (colspan) {
                    for (var k = 0; k < colspan - 1; ++k) {
                        outRow.push(null);
                    }
                }
            }
            out.push(outRow);
        };
        for (var R = 0; R < rows.length; ++R) {
            _loop_1(R);
        }
        return [out, ranges];
    };
    var datenum = function (date) {
        return (+date - +new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
    };
    var sheetFromDataArray = function (data) {
        var ws = {};
        var range = {
            s: {
                c: 10000000,
                r: 10000000
            },
            e: {
                c: 0,
                r: 0
            }
        };
        for (var R = 0; R !== data.length; ++R) {
            for (var C = 0; C !== data[R].length; ++C) {
                if (range.s.r > R)
                    range.s.r = R;
                if (range.s.c > C)
                    range.s.c = C;
                if (range.e.r < R)
                    range.e.r = R;
                if (range.e.c < C)
                    range.e.c = C;
                var cell = {
                    v: data[R][C],
                    t: '',
                    z: ''
                };
                if (cell.v === null)
                    continue;
                var cellRef = xlsx_1.default.utils.encode_cell({
                    c: C,
                    r: R
                });
                if (typeof cell.v === 'number')
                    cell.t = 'n';
                else if (typeof cell.v === 'boolean')
                    cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.t = 'n';
                    cell.z = xlsx_1.default.SSF.get_table()[14];
                    cell.v = datenum(cell.v);
                }
                else
                    cell.t = 's';
                ws[cellRef] = cell;
            }
        }
        if (range.s.c < 10000000) {
            ws['!ref'] = xlsx_1.default.utils.encode_range(range);
        }
        return ws;
    };
    var s2ab = function (s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xff;
        }
        return buf;
    };
    var exportTable2Excel = function (id) {
        var theTable = document.getElementById(id);
        if (theTable) {
            var oo = generateArray(theTable);
            var ranges = oo[1];
            var data = oo[0];
            var wsName = 'SheetJS';
            var wb = new Workbook();
            var ws = sheetFromDataArray(data);
            ws['!merges'] = ranges;
            wb.SheetNames.push(wsName);
            wb.Sheets[wsName] = ws;
            var wbout = xlsx_1.default.write(wb, {
                bookType: 'xlsx',
                bookSST: false,
                type: 'binary'
            });
            (0, file_saver_1.saveAs)(new Blob([s2ab(wbout)], {
                type: 'application/octet-stream'
            }), 'test.xlsx');
        }
    };
    exports.exportTable2Excel = exportTable2Excel;
});
//# sourceMappingURL=UtilsExcel.js.map